import { exists } from '@/api'

export interface BatchReserveContactMailCondition {
  dateFrom: string
  dateTo: string
  userRegistrationBranchCode: string
  receiveBranchCode: string
  isSendContacted: boolean
}

export function BatchReserveContactMailConditionFromJSON(
  json: any
): BatchReserveContactMailCondition {
  const _json = JSON.parse(json)

  return {
    dateFrom: exists(_json, 'date_from') ? _json.date_from : '',
    dateTo: exists(_json, 'date_to') ? _json.date_to : '',
    userRegistrationBranchCode: exists(_json, 'user_registration_branch_code')
      ? _json.user_registration_branch_code
      : '',
    receiveBranchCode: exists(_json, 'receive_branch_code')
      ? _json.receive_branch_code
      : '',
    isSendContacted: exists(_json, 'is_send_contacted')
      ? _json.is_send_contacted.toLowerCase() === 'true'
      : false
  }
}
